import { PaymentTerms } from '../../../types/enums/PaymentTerms';
import * as moment from 'moment';
import { MailingChannel } from '../../../types/enums/mailingChannel';

export const defaultCalculationData = {
    cpr: '',
    deductibleCode: 'P2',
    coverageOption: 1019,
    riskBasicNumber: 201,
    riskProductNumber: 161,
    paymentTerm: PaymentTerms.MONTHLY,
    productNumber: 3005,
    agreementProduct: 181,
    startDate: moment()
        .format('YYYY-MM-DD')
        .toString(),
    mailingChannel: MailingChannel.EMAIL
};
